exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete svg:hover path {\n  stroke: #b42318;\n}\n\n.MuiButtonBase-root.agree_btn {\n  color: #b42318;\n}\n\n.MuiButtonBase-root.refuse_btn {\n  color: #9e9e9e;\n}", ""]);

// exports
